import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "@user/components/Header";
import Footer from "@user/components/Footer";
import { api } from "@/lib/api";
import { BookOpen, Clock, ArrowRight } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export default function Articles() {
  const [articles, setArticles] = useState([]);
  const [category, setCategory] = useState("all");

  useEffect(() => {
    api.get("/articles", { params: { category: category !== "all" ? category : undefined } })
      .then((r) => setArticles(r.data))
      .catch(() => setArticles([]));
  }, [category]);

  const categories = Array.from(new Set(articles.map((a) => a.category)));

  return (
    <div className="min-h-screen bg-[#FAFAFA]">
      <Header />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 lg:py-12">
        <div className="mb-6">
          <span className="adv-chip">Knowledge Hub</span>
          <h1 className="mt-3 text-3xl sm:text-4xl font-extrabold text-slate-900" style={{ fontFamily: "Manrope" }}>
            Legal topics, in plain language
          </h1>
          <p className="mt-2 text-slate-600 max-w-2xl">
            No jargon. No fear. Understand your rights and what to do next.
          </p>
        </div>
        <div className="bg-white border border-slate-200 rounded-2xl p-4 flex gap-3">
          <Select value={category} onValueChange={setCategory}>
            <SelectTrigger className="md:w-[240px]" data-testid="article-filter-category">
              <SelectValue placeholder="Category" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">All categories</SelectItem>
              {categories.map((c) => <SelectItem key={c} value={c}>{c}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>

        <div className="mt-6 grid md:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="articles-grid">
          {articles.map((a) => (
            <Link
              key={a.id}
              to={`/articles/${a.slug}`}
              data-testid={`article-card-${a.slug}`}
              className="group bg-white border border-slate-200 rounded-2xl p-5 hover:shadow-lg hover:-translate-y-1 transition-all"
            >
              <div className="flex items-center gap-2">
                <div className="h-9 w-9 rounded-xl bg-[#DBEAFE] text-[#1E3A8A] grid place-items-center"><BookOpen size={16} /></div>
                <span className="text-xs font-bold uppercase tracking-wider text-[#1E3A8A]">{a.category}</span>
              </div>
              <h3 className="mt-3 text-lg font-bold text-slate-900 leading-snug" style={{ fontFamily: "Manrope" }}>{a.title}</h3>
              <p className="mt-2 text-sm text-slate-600 line-clamp-3">{a.summary}</p>
              <div className="mt-4 flex items-center justify-between text-xs text-slate-500">
                <span className="inline-flex items-center gap-1"><Clock size={12} />{a.read_time} min read</span>
                <span className="text-[#1E3A8A] font-semibold inline-flex items-center gap-1 group-hover:gap-2 transition-all">Read <ArrowRight size={12} /></span>
              </div>
            </Link>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
}
